/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-05-13 11:21:41
 * @LastEditors: luckymiaow
 */

import { ref, watchEffect } from 'vue';
import { deepCopy } from '../../util';
import type { BaseTree, IBaseTreeOptions, TreeNode } from '../types';
import { TreeNodeSlotsNode } from '../types';

export default ({ props }: { props: BaseTree }) => {
  const options = ref(deepCopy(props.options));

  // watchEffect(() => {
  //   options.value = deepCopy(props.options);
  //   if (props.fieldNames) {
  //     props.options.canAddChild = false;
  //     props.options.canDelete = false;
  //     props.options.canMove = false;
  //   }
  // });

  const rTitle = (node: TreeNode<unknown>, defaultTitle?: any) => {
    return node[props.fieldNames.title] ?? defaultTitle;
  };

  const rKey = (node: TreeNode<unknown>) => {
    return node[props.fieldNames.key];
  };

  const rChildren = (node: TreeNode<unknown>) => {
    return node[props.fieldNames.children];
  };

  const wTitle = (node: TreeNode<unknown>, t) => {
    node[props.fieldNames.title] = t;
  };

  const wKey = (node: TreeNode<unknown>, k) => {
    node[props.fieldNames.key] = k;
  };

  const wChildren = (node: TreeNode<unknown>, c) => {
    node[props.fieldNames.children] = c;
  };

  return { rTitle, rKey, rChildren, wTitle, wKey, wChildren, options };
};

export class DefaultOptions<T> implements IBaseTreeOptions<T> {
  canAddChild?: boolean = false;

  canRename?: boolean = false;

  canDelete?: boolean = false;

  canMove?: boolean = false;

  addChildAsync? = (directory: string, name: string, node: TreeNode<T>) => {
    return new Promise<TreeNode<T>>((resolve, reject) => {
      let path = name;
      if (directory) {
        path = `${directory}/${path}`;
      }

      resolve({ key: path, value: path, title: name, children: [], childCount: 0 });
    });
  };

  renameAsync? = (node: TreeNode<T>, newName: string) => {
    return new Promise((resolve, reject) => {
      resolve('local');
    });
  };

  deleteAsync? = (node: TreeNode<T>) => {
    return new Promise<void>((resolve, reject) => {
      resolve();
    });
  };

  SortMoveBefore? = (id: string, idRefer?: string) => {
    return new Promise<void>((resolve, reject) => {
      resolve();
    });
  };

  moveAsync? = (node: TreeNode<T>, newNode: TreeNode<T>) => {
    return new Promise<void>((resolve, reject) => {
      resolve();
    });
  };
}

export function mapTreeNode<T>(nodes: TreeNode<T>[], parent: TreeNodeSlotsNode<T> | null) {
  return nodes.map(node => {
    const mappedNode = new TreeNodeSlotsNode(node, parent);
    if (node?.children) mappedNode.children = mapTreeNode(node?.children, mappedNode);
    return mappedNode;
  });
}

export function fetchTreeNode<T>(nodes: TreeNodeSlotsNode<T>[]): TreeNode<T>[] {
  return nodes.map(node => {
    return {
      ...node.node,
      children: fetchTreeNode(node.children),
    };
  });
}

/**
 * @description: 同步修改子节点
 * @param {*} children
 * @param {*} oldVal
 * @param {*} newVal
 * @return {*}
 * @author: luckymiaow
 */
export async function loopEditNode<T>(children: TreeNodeSlotsNode<T>[], oldVal: string, newVal: string, type = null) {
  children.forEach(e => {
    e.value = e.value.replace(oldVal, newVal);
    if (type == 'local') e.key = e.key.replace(oldVal, newVal);
    if (e.children.length > 0) return loopEditNode(e.children, oldVal, newVal);
  });
}

export function loopFind<T>(
  data: TreeNode<T>[],
  key: string,
  callback: (arg0: TreeNode<T>, arg1: number, arg2: TreeNode<T>[]) => void | PromiseLike<void>
) {
  data.forEach(async (item: TreeNode<T>, index, arr: TreeNode<T>[]) => {
    if (item.key === key) {
      return callback(item, index, arr);
    }
    if (item.children && item.children.length > 0) {
      return loopFind(item.children, key, callback);
    }
  });
}

export function ObjectMap<T>(src: any, target: T): T {
  for (let k in src) {
    if (k in target) target[k] = src[k];
  }
  return target;
}
